// extracted by mini-css-extract-plugin
export default {"list__container":"style_list__container__h9aTu","searching":"style_searching__WiiAj","title":"style_title__cCz9A"};